// Vokshus reveal-on-scroll — adds .vk-revealed class to .vk-reveal
// elements when they enter the viewport. CSS handles the transition.
// The .vk-js class on <html> gates the hidden initial state so users
// without JS still see the content (progressive enhancement).
(() => {
  document.documentElement.classList.add('vk-js');

  const prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealAll = () => {
    document.querySelectorAll('.vk-reveal:not(.vk-revealed)').forEach(el => {
      el.classList.add('vk-revealed');
    });
  };

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', revealAll);
    if (document.readyState !== 'loading') revealAll();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('vk-revealed');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

  function init() {
    document.querySelectorAll('.vk-reveal').forEach(el => io.observe(el));

    // Hero auto-cascade — om hero är above-the-fold, kör entrance direkt
    // utan att vänta på scroll-trigger. Ger snyggare first-paint.
    requestAnimationFrame(() => {
      document.querySelectorAll('.vk-hero .vk-reveal').forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9) {
          el.classList.add('vk-revealed');
          io.unobserve(el);
        }
      });
    });

    // Safety net: tvinga reveal efter 1.5s om IntersectionObserver
    // av någon anledning inte fyrar (t.ex. transform-baserade föräldrar
    // som blockar observer eller iframe-edge-case i theme editor).
    setTimeout(revealAll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
